import { useQuery } from "@tanstack/react-query";
import { useAxios } from "../../../api/axios";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";


export const useFlipperVaultPRE = () => {
  const axios = useAxios();
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  return useQuery({
    queryKey: ["flipper-vaults-pre", searchParams.toString()],
    queryFn: async () => {
      try {
        const radius = searchParams.get("radius") ?? "100";
        const lat = searchParams.get("lat") ?? "33.949553";
        const lng = searchParams.get("lng") ?? "-118.112676";
        const view = searchParams.get("view") ?? "ALL ACCOUNTS";
        const acctType = searchParams.get("acctType") ?? "FT VERIFIED";
        const pubPropertyId = searchParams.get("pid") ?? "";
        const searchText = searchParams.get("searchText") ?? "";
        const order = searchParams.get("order") ?? "Low to High";
        const orderEmail = searchParams.get("orderEmail") || "";
        const checkoutStatus = searchParams.get("checkoutStatus") ?? "OFF";
        const shouldIgnoreRadius =
        searchParams.get("shouldIgnoreRadius") ?? true;

        const sortBy = orderEmail && orderEmail.length > 0 ? "emailScore" : "interestScore";
        const sortDir = (orderEmail && orderEmail.length > 0
          ? orderEmail
          : order) === "Low to High"
          ? "ASC"
          : "DESC";

        const urlKey = `${t(
          "inv-exchange-account-listing"
        )}?page=1&pubPropertyId=${pubPropertyId}&limit=20&radius=${radius}&shouldIgnoreRadius=${shouldIgnoreRadius}&longitude=${lng}&latitude=${lat}${
          acctType?.length > 0 ? `&acctType=${acctType}` : ""
        }${view?.length > 0 ? `&view=${view}` : ""}${
          searchText?.length > 0
            ? `&searchTxt=${encodeURIComponent(searchText)}`
            : ""
        }&orderBy=${sortBy}&order=${sortDir}${
          checkoutStatus?.length > 0
            ? `&checkoutStatus=${
                checkoutStatus === "CHECKED OUT"
                  ? "CHECKED OUT ONLY"
                  : checkoutStatus === "AVAILABLE"
                  ? "AVAILABLE ONLY"
                  : "ALL"
              }`
            : ""
        }`;

        const response = await axios.get(urlKey);
        return {
          items: response.data?.data?.acctPre?.flatMap((pre: any) =>
            pre?.pre?.map((preItem: any) => ({
              ...preItem,
              acctId: pre.acctId,
              acctName: pre.acctName
            }))
          ),
          full_count: response.data.data[0]?.full_count || 0
        };
      } catch (error) {
        console.error("Error fetching flipper vault data:", error);
        return {
          items: [],
          full_count: 0
        };
      }
    }
  });
};
